import { render, staticRenderFns } from "./ResumoAnual.vue?vue&type=template&id=1121df77"
import script from "./ResumoAnual.vue?vue&type=script&lang=ts"
export * from "./ResumoAnual.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports